// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu-item.navmenu.warning-active .navmenu-title{color:#ff3b30!important;animation:warning-blink 1s steps(2,jump-none) infinite}.el-menu-item.navmenu.warning-active{background:rgba(255,59,48,.15)!important;box-shadow:0 0 8px 2px #ff3b30;animation:warning-blink-bg 1s steps(2,jump-none) infinite}@keyframes warning-blink{0%,to{opacity:1}50%{opacity:.2}}@keyframes warning-blink-bg{0%,to{box-shadow:0 0 8px 2px #ff3b30}50%{box-shadow:0 0 0 0 transparent}}", ""]);
// Exports
module.exports = exports;
